import axios from 'axios'

// 跨域认证信息 header 名
const xsrfHeaderName = 'Authorization'

const BASEURL = "https://simservice.wuhanpe.com/v1/cloud/server"

axios.defaults.timeout = 5000
axios.defaults.withCredentials= true
axios.defaults.xsrfHeaderName= xsrfHeaderName
axios.defaults.xsrfCookieName= xsrfHeaderName

// http method
const METHOD = {
  GET: 'get',
  POST: 'post'
}

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
async function request(url, method, params, config) {
  switch (method) {
    case METHOD.GET:
      return axios.get(url, {params, ...config})
    case METHOD.POST:
      return axios.post(url, params, config)
    default:
      return axios.get(url, {params, ...config})
  }
}

/**
 * 
 */
 export async function questionList() {
    return request(BASEURL+'/help/content/idList', METHOD.GET, {
    })
  }

  export async function questionDetail(id) {
    return request(BASEURL+'/help/content/idInfo?id='+id, METHOD.GET, {
    })
  }